import { apiGet, apiPost } from '../../fetch/apiService';

export function getPermissionProfiles() {
	return apiGet('permission-profiles');
}

export function postMembersForPermissionProfiles(permissionProfileUuid, memberIds) {
	return apiPost(`permission-profiles/${permissionProfileUuid}/set_members/`, memberIds);
}
